import React, { useState, useEffect } from 'react';
import { Link, Outlet, useLocation } from 'react-router-dom';
import { FaBars, FaBookOpen, FaSignOutAlt, FaBell, FaUser, FaUserTimes } from 'react-icons/fa';
import '../styles/Dashboard.css';
import '../styles/Navbar.css';
import logo from '../assets/logo.png';

const Dashboard = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const location = useLocation();

  const toggleSidebar = () => setSidebarOpen(!sidebarOpen);

  useEffect(() => {
    setSidebarOpen(false);
  }, [location]);

  return (
    <div className="dashboard-layout">
      {/* Overlay for mobile/tablet when sidebar is open */}
      {sidebarOpen && <div className="sidebar-overlay" onClick={toggleSidebar}></div>}

      {/* Sidebar */}
      <nav className={`navbar ${sidebarOpen ? 'open' : ''}`}>
        <div className="nav-logo">
          <img src={logo} alt="Logo" className="logo" />
        </div>
        <h2 className="admin">Admin Panel</h2>
        <ul className="nav-menu">
          <li><Link to="/dashboard/chapters"><FaBookOpen /> Chapters</Link></li>
          <li><Link to="/dashboard/user-management"><FaUser /> User Management</Link></li>
          <li><Link to="/dashboard/delete-user"><FaUserTimes /> Delete User</Link></li>
          <li><Link to="/dashboard/alert-schedule"><FaBell /> Alerts & Schedule</Link></li>
          <li><Link to="/logout"><FaSignOutAlt /> Logout</Link></li>
        </ul>
      </nav>

      {/* Hamburger (always visible) */}
<button
  className="hamburger fixed-top"
  onClick={toggleSidebar}
  aria-label="Toggle Navigation"
>
  <FaBars />
</button>


      {/* Main content */}
      <main className="main-view">
        <div className="main-inner">
          <Outlet />
        </div>
      </main>
    </div>
  );
};

export default Dashboard;
